import "core-js/modules/es.function.name.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('div', {
    staticClass: "im m_clearLR",
    style: _vm.openHistory ? 'min-width:896px' : ''
  }, [_c('img', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy",
      value: require('@/assets/images/close.png'),
      expression: "require('@/assets/images/close.png')"
    }],
    staticClass: "close",
    attrs: {
      "alt": ""
    },
    on: {
      "click": _vm.closeIm
    }
  }), _c('div', {
    staticClass: "im-main m-floatL"
  }, [_c('div', {
    staticClass: "header drop-header",
    style: _vm.openHistory ? 'min-width:896px' : ''
  }, [_vm._v("在线客服")]), _c('div', {
    ref: "content",
    staticClass: "im-content",
    on: {
      "scroll": _vm.load
    }
  }, [_c('ul', {
    staticClass: "data-list"
  }, _vm._l(_vm.messageList, function (item, index) {
    return _c('li', {
      key: index
    }, [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: item.flow == 'status' && item.type != 'goodsInfo',
        expression: "item.flow == 'status' && item.type != 'goodsInfo'"
      }],
      staticClass: "im-dialogue"
    }, [_c('span', [_vm._v(_vm._s(item.payload.text))])]), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: item.flow == 'in',
        expression: "item.flow == 'in'"
      }],
      staticClass: "m-clearLR left-chart"
    }, [_c('div', {
      staticClass: "m-floatL"
    }, [_c('img', {
      staticStyle: {
        "width": "40px",
        "height": "40px",
        "border-radius": "20px"
      },
      attrs: {
        "isClick": "false",
        "src": _vm.custerInfo.custHeadImg ? _vm.custerInfo.custHeadImg : require('@/assets/images/default.png')
      }
    })]), _c('div', {
      staticClass: "m-floatL",
      staticStyle: {
        "margin-left": "8px"
      }
    }, [_c('div', {
      staticClass: "left-name"
    }, [_vm._v(_vm._s(_vm.custerInfo.custNickName))]), item.type == -1 ? _c('div', {
      staticClass: "robot-box"
    }, [_c('div', {
      staticClass: "left-text"
    }, [_vm._v(" " + _vm._s(item.payload.itemText) + " ")]), _c('ul', _vm._l(item.payload.itemData, function (itemChild, index) {
      return _c('li', {
        key: index,
        staticClass: "text-line",
        on: {
          "click": function click($event) {
            return _vm.sendRobot(itemChild);
          }
        }
      }, [_vm._v(" " + _vm._s(itemChild.itemTitle) + " ")]);
    }), 0)]) : item.type != 'TIMImageElem' && item.type != 'goodsInfo' ? _c('div', {
      staticClass: "left-text",
      domProps: {
        "innerHTML": _vm._s(_vm.replaceSrc(item.payload.text))
      }
    }) : item.type == 'goodsInfo' ? _c('div', {
      staticClass: "right-text m-floatR right-goods"
    }, [_c('div', {
      staticClass: "zx-goodsing",
      on: {
        "click": function click($event) {
          return _vm.toDetailUrl(item.payload.id);
        }
      }
    }, [_c('div', {
      staticClass: "m-clearLR goods-info"
    }, [_c('div', {
      staticClass: "goods-img m-floatL"
    }, [_c('img', {
      attrs: {
        "src": item.payload.url,
        "alt": ""
      }
    })]), _c('div', {
      staticClass: "m-floatL goods-text"
    }, [_c('div', {
      staticClass: "text-line"
    }, [_vm._v(_vm._s(item.payload.name))]), _c('div', {
      staticClass: "price"
    }, [_c('span', {
      staticClass: "sp-1"
    }, [_vm._v("¥")]), _c('span', {
      staticClass: "sp-2"
    }, [_vm._v(_vm._s(_vm._f("calcPrice")(item.payload.price.split(',')[0])))]), _c('span', {
      staticClass: "sp-3"
    }, [_vm._v("." + _vm._s(_vm._f("calcPrice2")(item.payload.price.split(',')[0])))]), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: item.payload.price.split(',').length > 1 && item.payload.price.split(',')[0] != item.payload.price.split(',')[1],
        expression: "\n                            item.payload.price.split(',').length > 1 &&\n                            item.payload.price.split(',')[0] != item.payload.price.split(',')[1]\n                          "
      }]
    }, [_c('span', {
      staticStyle: {
        "color": "#ff3232"
      }
    }, [_vm._v("~")]), _c('span', {
      staticClass: "sp-1"
    }, [_vm._v("¥")]), _c('span', {
      staticClass: "sp-2"
    }, [_vm._v(_vm._s(_vm._f("calcPrice")(item.payload.price.split(',')[1])))]), _c('span', {
      staticClass: "sp-3"
    }, [_vm._v("." + _vm._s(_vm._f("calcPrice2")(item.payload.price.split(',')[1])))])])])])])])]) : _c('div', {
      staticClass: "left-text right-pic",
      domProps: {
        "innerHTML": _vm._s(item.payload.text)
      }
    })])]), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: item.flow == 'out',
        expression: "item.flow == 'out'"
      }],
      staticClass: "m-clearLR right-chart"
    }, [_c('div', {
      staticClass: "m-floatR"
    }, [_c('img', {
      staticStyle: {
        "width": "40px",
        "height": "40px",
        "border-radius": "20px"
      },
      attrs: {
        "isClick": "false",
        "src": _vm.userInfo.faceUrl ? _vm.userInfo.faceUrl : require('@/assets/images/default.png')
      }
    })]), item.type != 'TIMImageElem' && item.type != 'goodsInfo' ? _c('div', {
      staticClass: "right-text m-floatR",
      domProps: {
        "innerHTML": _vm._s(_vm.replaceSrc(item.payload.text))
      }
    }) : item.type == 'goodsInfo' ? _c('div', {
      staticClass: "right-text m-floatR right-goods"
    }, [_c('div', {
      staticClass: "zx-goodsing",
      on: {
        "click": function click($event) {
          return _vm.toDetailUrl(item.payload.id);
        }
      }
    }, [_c('div', {
      staticClass: "m-clearLR goods-info"
    }, [_c('div', {
      staticClass: "goods-img m-floatL"
    }, [_c('img', {
      attrs: {
        "src": item.payload.url,
        "alt": ""
      }
    })]), _c('div', {
      staticClass: "m-floatL goods-text"
    }, [_c('div', {
      staticClass: "text-line"
    }, [_vm._v(_vm._s(item.payload.name))]), _c('div', {
      staticClass: "price"
    }, [_c('span', {
      staticClass: "sp-1"
    }, [_vm._v("¥")]), _c('span', {
      staticClass: "sp-2"
    }, [_vm._v(_vm._s(_vm._f("calcPrice")(item.payload.price.split(',')[0])))]), _c('span', {
      staticClass: "sp-3"
    }, [_vm._v("." + _vm._s(_vm._f("calcPrice2")(item.payload.price.split(',')[0])))]), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: item.payload.price.split(',').length > 1 && item.payload.price.split(',')[0] != item.payload.price.split(',')[1],
        expression: "\n                          item.payload.price.split(',').length > 1 &&\n                          item.payload.price.split(',')[0] != item.payload.price.split(',')[1]\n                        "
      }]
    }, [_c('span', {
      staticStyle: {
        "color": "#ff3232"
      }
    }, [_vm._v("~")]), _c('span', {
      staticClass: "sp-1"
    }, [_vm._v("¥")]), _c('span', {
      staticClass: "sp-2"
    }, [_vm._v(_vm._s(_vm._f("calcPrice")(item.payload.price.split(',')[1])))]), _c('span', {
      staticClass: "sp-3"
    }, [_vm._v("." + _vm._s(_vm._f("calcPrice2")(item.payload.price.split(',')[1])))])])])])])])]) : _c('div', {
      staticClass: "right-text m-floatR right-pic",
      domProps: {
        "innerHTML": _vm._s(item.payload.text)
      }
    })]), item.type == 'isGoods' && _vm.goodsInfo.productName ? _c('div', {
      staticClass: "zx-goods"
    }, [_c('div', {
      staticClass: "m-clearLR goods-info"
    }, [_c('div', {
      staticClass: "goods-img m-floatL"
    }, [_c('img', {
      attrs: {
        "src": _vm.goodsInfo.listImagePath.cdnFilePathPc,
        "alt": ""
      }
    })]), _c('div', {
      staticClass: "m-floatL goods-text"
    }, [_c('div', {
      staticClass: "text-line"
    }, [_vm._v(_vm._s(_vm.goodsInfo.productName))]), _c('div', {
      staticClass: "price"
    }, [_c('span', {
      staticClass: "sp-1"
    }, [_vm._v("¥")]), _c('span', {
      staticClass: "sp-2"
    }, [_vm._v(_vm._s(_vm._f("calcPrice")(_vm.goodsInfo.lowestPrice.split(',')[0])))]), _c('span', {
      staticClass: "sp-3"
    }, [_vm._v("." + _vm._s(_vm._f("calcPrice2")(_vm.goodsInfo.lowestPrice.split(',')[0])))]), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: _vm.goodsInfo.lowestPrice.split(',').length > 1 && _vm.goodsInfo.lowestPrice.split(',')[0] != _vm.goodsInfo.lowestPrice.split(',')[1],
        expression: "\n                      goodsInfo.lowestPrice.split(',').length > 1 &&\n                      goodsInfo.lowestPrice.split(',')[0] != goodsInfo.lowestPrice.split(',')[1]\n                    "
      }]
    }, [_c('span', {
      staticStyle: {
        "color": "#ff3232"
      }
    }, [_vm._v("~")]), _c('span', {
      staticClass: "sp-1"
    }, [_vm._v("¥")]), _c('span', {
      staticClass: "sp-2"
    }, [_vm._v(_vm._s(_vm._f("calcPrice")(_vm.goodsInfo.lowestPrice.split(',')[1])))]), _c('span', {
      staticClass: "sp-3"
    }, [_vm._v("." + _vm._s(_vm._f("calcPrice2")(_vm.goodsInfo.lowestPrice.split(',')[1])))])])])])]), _c('div', {
      staticClass: "footer-text",
      on: {
        "click": _vm.consultGoods
      }
    }, [_vm._v("咨询商品")])]) : _vm._e()]);
  }), 0)]), _c('div', {
    staticClass: "send-footer m-clearLR"
  }, [_c('div', {
    staticClass: "send-text m-floatL"
  }, [_c('div', {
    ref: "message",
    staticClass: "send-text-content m-floatL",
    attrs: {
      "contenteditable": !_vm.isOver
    },
    on: {
      "focus": _vm.calcInput,
      "keydown": _vm.handleKeyCodeDown,
      "paste": _vm.pasteVal,
      "keyup": _vm.handleKeyCodeUp,
      "blur": _vm.getEndRange
    }
  })]), _c('div', {
    staticClass: "send-btn",
    class: {
      disable: _vm.isOver || !_vm.isCoding
    },
    on: {
      "click": _vm.sendMessage
    }
  }, [_vm._v(" 发送 ")]), _c('div', {
    staticClass: "m-floatL send-bq",
    class: _vm.isOver ? 'disable' : _vm.openEmojis ? 'active' : '',
    on: {
      "click": _vm.openEmojisDia
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.openEmojis,
      expression: "openEmojis"
    }],
    staticClass: "emojis m-clearLR"
  }, _vm._l(_vm.emojis, function (item) {
    return _c('img', {
      key: item.code,
      staticClass: "m-floatL",
      attrs: {
        "src": item.src,
        "emoji-text": item.text,
        "alt": ""
      },
      on: {
        "click": function click($event) {
          $event.stopPropagation();
          return _vm.selectEmojis(item);
        }
      }
    });
  }), 0), _c('i', {
    staticClass: "iconfont iconmine_icon_biaoqing"
  })]), _c('div', {
    staticClass: "m-floatL send-img",
    class: _vm.isOver ? 'disable' : '',
    on: {
      "click": _vm.openInput
    }
  }, [_c('input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: 1 == 2,
      expression: "1 == 2"
    }],
    ref: "imagePic",
    staticClass: "image-pic",
    attrs: {
      "type": "file"
    },
    on: {
      "change": _vm.sendImageMessage
    }
  }), _c('i', {
    staticClass: "iconfont iconmine_icon_zhaopian1"
  })]), _c('div', {
    staticClass: "m-floatL send-history",
    class: _vm.openHistory ? 'active' : '',
    on: {
      "click": _vm.openSelfHistory
    }
  }, [_c('i', {
    staticClass: "iconfont iconmine_icon_liaotianjilu"
  })])])]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.openHistory,
      expression: "openHistory"
    }],
    staticClass: "im-history m-floatL"
  }, [_c('div', {
    staticClass: "back-header"
  }), _c('div', {
    staticClass: "header m-clearLR"
  }, [_c('div', {
    staticClass: "input-search m-floatL"
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    nativeOn: {
      "keyup": function keyup($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.btnSearch.apply(null, arguments);
      }
    },
    model: {
      value: _vm.listQuery.keyword,
      callback: function callback($$v) {
        _vm.$set(_vm.listQuery, "keyword", $$v);
      },
      expression: "listQuery.keyword"
    }
  }), _c('img', {
    staticClass: "search-img",
    attrs: {
      "src": require("@/assets/images/search.png"),
      "alt": ""
    }
  }), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.listQuery.keyword,
      expression: "listQuery.keyword"
    }],
    staticClass: "search-close",
    attrs: {
      "src": require("@/assets/images/search-close.png"),
      "alt": ""
    },
    on: {
      "click": _vm.clearSearch
    }
  })], 1), _c('div', {
    staticClass: "search-btn m-floatL",
    on: {
      "click": _vm.btnSearch
    }
  }, [_vm._v("搜索")])]), _c('div', {
    ref: "historyContent",
    staticClass: "im-content",
    on: {
      "scroll": _vm.historyLoad
    }
  }, [_c('ul', [_vm._l(_vm.historyList, function (item, index) {
    return _c('li', {
      key: index,
      staticClass: "history-li"
    }, [_c('div', {
      staticClass: "h-top m-clearLR"
    }, [_c('div', {
      staticClass: "h-name m-floatL"
    }, [_vm._v(" " + _vm._s(item.flow == 'out' ? item.userAccountName.split(' ')[0] : item.custAccount) + " ")]), _c('div', {
      staticClass: "h-date m-floatR"
    }, [_vm._v(_vm._s(_vm._f("formatDate")(item.time * 1000)))])]), _c('div', {
      staticClass: "h-content m-clearLR",
      domProps: {
        "innerHTML": _vm._s(_vm.replaceSrc(item.payload.text))
      }
    })]);
  }), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.historyList.length <= 0 || _vm.noMore,
      expression: "historyList.length <= 0 || noMore"
    }],
    staticClass: "im-dialogue"
  }, [_c('span', [_vm._v("暂无数据")])])], 2)])]), _vm.showImg ? _c('bigImg', {
    attrs: {
      "imgSrc": _vm.imgSrc
    },
    on: {
      "clickit": _vm.viewImg
    }
  }) : _vm._e(), _c('input', {
    ref: "emojisFocus",
    staticStyle: {
      "position": "absolute",
      "z-index": "-1",
      "left": "100px",
      "width": "0px",
      "height": "0px"
    },
    attrs: {
      "type": "text"
    },
    on: {
      "blur": _vm.emojisBlur
    }
  })], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };